'use client';

import { clsx } from 'clsx';
import { FC } from 'react';
import { IconHeart } from 'src/general/Icons/IconHeart';
import { IconHeartFilled } from 'src/general/Icons/IconHeartFilled';
import { ProductListDataRow } from 'src/types/CataloguePage.types';
import { ButtonIcon } from '../Button/ButtonIcon';
import { useToggleWatchList } from './hooks/useToggleWatchList';

type AddToWatchListIconProps = {
  sku: string;
  className?: string;
  disableSnackbar?: boolean;
  product?: Partial<ProductListDataRow>;
  onWatchlistStatusChange?: () => Promise<void>;
};

export const AddToWatchListIcon: FC<AddToWatchListIconProps> = ({
  sku,
  className,
  product = {},
  onWatchlistStatusChange,
  disableSnackbar = false,
}) => {
  const { userAddedItem, handleToggle, isLoading } = useToggleWatchList(
    sku,
    disableSnackbar,
    onWatchlistStatusChange,
    product,
  );

  return (
    <ButtonIcon
      type="button"
      size="small"
      variant="tertiary"
      styling="round"
      className={clsx(
        'transition-background 100ms z-10 h-8 w-8 cursor-pointer border-none bg-transparent ease-in-out',
        className,
        {
          ['!text-pin-500']: userAddedItem,
        },
      )}
      onClick={handleToggle}
      data-testid={`AddToWatchList-component-button-${userAddedItem ? 'Saved' : 'Save'}`}
      title="Add to watchlist"
      disabled={isLoading}
      Icon={userAddedItem ? IconHeartFilled : IconHeart}
    />
  );
};
